export const homes = {
  page_heading: "Homes",

  editor_label_name: "Name",
  editor_label_address_line1: "Address",
  editor_label_address_line2: "Address, line 2",
  editor_label_address_postal_code: "Postal Code",
  editor_label_address_region: "City",

  number_admins_assigned: "person(s)",
  operation_manager_heading: "Process Owner - Authorization 2",
  operation_manager_add_placeholder: "Add new, enter email address",
  confirm_remove_manager_operation:
    "Do you really want to remove the process owner:\n\n",

  error_conflict: "This user is already admin in other organisation.",
  error_conflict_connected:
    "This account is connected with the other organisation.",

  home_manager_heading: "Process Owner - Authorization 3",
  home_manager_add_placeholder: "Add new, enter email address",
  confirm_remove_manager_home:
    "Do you really want to remove the process owner:\n\n",
};
